interface SessionStorageType {
  get<T>(key: string, defaultValue?: T): T | undefined | null;
  set(key: string, value: any): void;
  remove(key: string): void;
  clear(): void;
}

let SessionStorage: SessionStorageType;
if (__MOBILE__) {
  // just hand asyncStorage, no sense of sessionStorage in IOS nor is it meaningful
  SessionStorage = require('./native/Storage').impl;
} else {
  SessionStorage = require('./web/SessionStorage').impl;
}

export {SessionStorage};
